import { render, staticRenderFns } from "./TipoJornada.vue?vue&type=template&id=1afa778e&scoped=true"
import script from "./TipoJornada.vue?vue&type=script&lang=js"
export * from "./TipoJornada.vue?vue&type=script&lang=js"
import style0 from "./TipoJornada.vue?vue&type=style&index=0&id=1afa778e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa778e",
  null
  
)

export default component.exports